export const BOOST = 'BOOST';
export const NAVIGATION = 'NAVIGATION';
export const PRODUCT_QUERIES = 'PRODUCT_QUERIES';
export const OFFER_GROUPS = 'OFFER_GROUPS';
export const OFFER_CODES = 'OFFER_CODES';
export const PRODUCT_MERCH = 'PRODUCT MERCH';
